import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

import numbro from 'numbro';
import moment from 'moment';
import 'moment/locale/hr';
import api from "@/lib/api";

const hostname = window.location.hostname;
const defaultLang = hostname === "www.sigurnestaze.hr" ? 'hr' : hostname === "www.safetrails.hr" ? 'en' : 'hr';

i18n
  .use(HttpApi)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    ns: ['translation', 'map'],
    defaultNS: 'translation',
    // lng: defaultLang,
    fallbackLng: defaultLang,
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      // TODO see on what endpoint will translations be
      loadPath: '/api/v1/translations/{{lng}}/{{ns}}',
      request: (
        options: object,
        url: string,
        payload: object,
        callback: any
      ) => {
        const apiInstance = new api();
        return apiInstance
          ._get(url)
          .then((resp: any) => {
            if (resp.success) {
              callback(null, {
                status: 200,
                data: JSON.stringify(resp.data) || '',
              });
            }
          })
          .catch((err: any) => {
            callback(err);
          });
      },
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  numbro.setLanguage(lng);
});

export default i18n;
